import { cn } from '@/lib/utils';
import { type ReactNode } from 'react';

type Props = {
    children: ReactNode;
    className?: string;
}

export const PageFooter = ({
    children,
    className
}: Props) => {
    return (
        <div className={cn("flex justify-end w-full gap-2", className)}>
            {children}
        </div>
    )
}
